import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import CharacterSpeak from './CharacterSpeak';//eslint-disable-line import/no-named-as-default
import LearnerSpeak from './LearnerSpeak';//eslint-disable-line import/no-named-as-default
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as appConstants from '../../../constants/appConstants';

import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';
import {getChildObjectComponentByType} from "../../../helpers/componentHelper";

class ConversationDialog extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            initialised: false,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            screenObject: this.props.screenObject,
            locale: appHelper.getLocalData(this.props.screenObject),
            renderedDialogs: [],
            responseData: {
                latestResponse: {}
            },
            callbacks: {},

            showProgressionButton: false,
            maxSpeechCounter: 2,
            speechCounter: 0,
            currentIndex: 0,
            showStepProgressionButton: false,
            speechDelay: 0.2,
            readyForNextBubble: false,
            screenStatus: "",
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(), this.props.callbacks.getScreenId(), this.props.screenObject.asset_id),
            continue_label: appHelper.getLocaleString("continue_label"),
            progressionHandled: false,
        };

        this.handleProgression = this.handleProgression.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.setDialog = this.setDialog.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.onObjectComplete = this.onObjectComplete.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.onStepProgressionBtnClicked = this.onStepProgressionBtnClicked.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getSpeechDelay = this.getSpeechDelay.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);

    }

    componentDidMount() {
        this.getAssets();
        this.setCallbacks();
        this.setDialog(0);
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
        this.getScreenStatus();
        this.scrollToTop();
        this.getObjectStatus();
    }

    componentWillReceiveProps(nextProps) {
        this.getScreenStatus();
        this.getObjectStatus();
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.readyForNextBubble) {
            this.setDialog(this.state.currentIndex);
        }
    }

    getAssets() {
        let objectUserData = {};
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            let subScreenParent = this.props.callbacks.getSubScreenParent();
            let screen_id = this.props.callbacks.getScreenId();
            if (appHelper.isDefined(subScreenParent)) {
                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
            } else if (this.state.isResourceObject) {
                objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
            } else {
                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
            }
        }

        if (appHelper.isDefined(this.state.screenObject.audio)) {
            let audio = appHelper.getAudioAsset(this.state.screenObject.audio);
            let audioObj = {
                audioRef: `audio_${audio.id}_${audio.type}`,
            };

            if (objectUserData.status !== objectConstants.STATUS_COMPLETE) {
                this.props.actions.setAudio(audioObj);
            }
        }
    }

    getObjectStatus() {
        let objectUserData = {};
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            let subScreenParent = this.props.callbacks.getSubScreenParent();
            let screen_id = this.props.callbacks.getScreenId();
            if (appHelper.isDefined(subScreenParent)) {
                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
            } else {
                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
            }
        }

        if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({status: objectConstants.STATUS_COMPLETE});
        }
    }

    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.props.callbacks, {
                onObjectComplete: this.onObjectComplete
            }),
        });
    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    onObjectComplete(index) {
        let nextIndex = index + 1;
        if (nextIndex < this.state.screenObject.dialogs.length) {
            /*if(this.state.speechCounter + 1 >= this.state.maxSpeechCounter && this.state.status !== objectConstants.STATUS_COMPLETE){
                this.setState({
                    //showStepProgressionButton: true,
                    showStepProgressionButton: false,
                    currentIndex: nextIndex
                });
            }else{*/
                this.scrollToTop();
            this.setState({
                currentIndex: nextIndex,
                readyForNextBubble: true,
                speechCounter: this.state.speechCounter + 1
            });
            /* }*/
        } else {
            this.onComplete();
        }

    }

    setDialog(index) {
        this.setState({readyForNextBubble: false});
        let dialog = Object.assign({}, this.state.screenObject.dialogs[index]);
        let dialogType = Object.assign({}, getChildObjectComponentByType(dialog.object_type),
            {
                data: dialog,
                index: index
            }
        );
        this.setState({renderedDialogs: dataHelper.immutablePush(this.state.renderedDialogs, dialogType)});
    }

    scrollToTop() {
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE) {
            let question = this.refs[this.state.screenObject.asset_id];
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo)) {
                    scrollTo(question.offsetTop);
                }
            }, objectConstants.SCROLL_TO);
        }
    }


    onComplete() {
        let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
        if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
            if (!hasNextObject) {
                this.handleProgression();
                this.enableProgression();
            } else {
                this.enableProgression();
            }

        } else {
            this.handleProgression();
        }
        this.scrollToTop();
    }


    handleProgression() {
        if(!this.state.progressionHandled) {
            this.setState({progressionHandled: true});
            let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
            let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
            let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
            let completionData = {
                progression: progressionRule,
                progressionType: progressionType,
                progressionGoToId: progressionGoToId,
                asset_id: this.state.screenObject.asset_id,
                status: objectConstants.STATUS_COMPLETE,
                asset_type_code: this.state.screenObject.asset_type_code,
                navigateToNextScreen: appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
                index: this.props.index
            };

            this.props.callbacks.onObjectComplete(completionData);
        }
    }

    enableProgression() {
        //if(!this.props.callbacks.isReviewMode()){
        this.setState({showProgressionButton: true});
        //}
        this.scrollToTop();
    }

    onProgressionBtnClicked() {
        this.setState({showProgressionButton: false});
        if (this.props.callbacks.hasNextObject(this.props.index)) {
            this.handleProgression();
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    onStepProgressionBtnClicked() {
        this.setState({
            readyForNextBubble: true,
            speechCounter: 0,
            showStepProgressionButton: false
        });
    }

    getSpeechDelay() {
        return (this.state.speechCounter === 0 || this.state.status === objectConstants.STATUS_COMPLETE) ? 0 : this.state.speechDelay;
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    render() {
        return (


            <div className="content-dialogs" ref={this.state.screenObject.asset_id}>
                <div className="object-wrapper">
                    {
                        appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0
                        ?
                            <div className={`content-character-expression`}>
                                <img src={this.getImagePath(this.props.characterPose.src)} alt=""/>
                            </div>
                        :
                            null
                    }
                    <div className="conversation-dialog">
                        {
                            this.state.screenObject.show_title
                                ? <h4 className="bold" dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                : null
                        }
                        {this.state.renderedDialogs.map(dialog =>
                            <div key={`diaglog_${dialog.index}`}>
                                <dialog.component asset_id={this.state.screenObject.asset_id}
                                                  index={dialog.index} dialog={dialog.data}
                                                  callbacks={this.state.callbacks}
                                                  delay={this.getSpeechDelay()}/>
                            </div>
                        )}
                        {this.state.showStepProgressionButton
                            ? <Button label={this.state.continue_label}
                                      id={`${this.state.screenObject.asset_id}_step_button`}
                                      onClick={this.onStepProgressionBtnClicked}/>
                            : null
                        }
                    </div>
                    {this.state.showProgressionButton
                        ? <Button label={this.state.continue_label}
                                  id={`${this.state.screenObject.asset_id}_button`}
                                  onClick={this.onProgressionBtnClicked}/>
                        : null
                    }

                </div>
            </div>

        );
    }
}

ConversationDialog.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    characterPose: PropTypes.object,
    userData: PropTypes.object.isRequired,
    index: PropTypes.number,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

ConversationDialog.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConversationDialog);



/** WEBPACK FOOTER **
 ** ./src/components/objects/conversationDialog/ConversationDialog.js
 **/